<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DRMH">Publisher’s Notice</p>
<p class="DRMF">The publisher has provided this ebook to you without Digital Rights Management (DRM) software applied so that you can enjoy reading it on your personal devices. This ebook is for your personal use only. You may not print or post this ebook, or make this ebook publicly available in any way. You may not copy, reproduce, or upload this ebook except to read it on your personal devices.</p>
<p class="DRMTX">Copyright infringement is against the law. If you believe the copy of this ebook you are reading infringes on the author’s copyright, please notify the publisher at: <a href="http://simonandschuster.biz/online_piracy_report" target="_blank">simonandschuster.biz/online_piracy_report</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// drm.vue?485c7ef1